import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please sign in.");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background factory-grid p-6">
      <div className="w-full max-w-sm card-surface p-8">
        <h1 className="text-xl font-display font-bold text-white">Choose a new password</h1>
        {!token ? (
          <p className="text-sm text-rose-400 mt-3">Missing or invalid reset link.</p>
        ) : (
          <form onSubmit={submit} className="mt-5 space-y-4">
            <div>
              <Label htmlFor="rp-pw">New password</Label>
              <Input id="rp-pw" data-testid="reset-password" type="password" value={password} required minLength={6}
                onChange={(e) => setPassword(e.target.value)} className="mt-1.5" placeholder="••••••••" />
            </div>
            {error && <p className="text-sm text-rose-400">{error}</p>}
            <Button type="submit" disabled={busy} data-testid="reset-submit"
              className="w-full bg-primary text-primary-foreground hover:bg-amber-400 font-semibold">
              {busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />} Reset password
            </Button>
          </form>
        )}
        <Link to="/login" className="mt-6 inline-flex items-center gap-1.5 text-sm text-amber-400 hover:underline">
          <ArrowLeft className="h-4 w-4" /> Back to sign in
        </Link>
      </div>
    </div>
  );
}
